import { bool, array, string, func, object, any } from 'prop-types'
import { forwardRef } from 'react'
import { Tooltip } from '@opallabs/lapidary'
import { kuiperClassNames } from '../../utils'
import WithMenuComponent from './component'

const WithMenu = (Component, opts = {}) => {
  const componentName =
    Component.displayName || Component.name || Component.constructor.name

  const WrappedComponent = forwardRef(function WrappedComponent(props, ref) {
    const { options, menuContent } = props

    if (options || menuContent) {
      const {
        avatared,
        canSelectAll,
        clearSearchOnSelect,
        disabled,
        isMultiSelect,
        menuClassName,
        onChange,
        onClearAll,
        onRemove,
        onSelect,
        onSuggest,
        optionDecorator,
        optionsType,
        overscanCount,
        rowHeight,
        searchable,
        selectMatchOnEnter,
        selectedComparator,
        showDeselectIcon,
        showSelected,
        tooltip,
        value,
      } = props

      const popoverOptions = {
        ...opts.popoverOptions,
        ...props.popoverOptions,
      }

      return (
        <div className={kuiperClassNames('input', 'with-menu-wrapper')}>
          <WithMenuComponent
            alwaysOpen={opts.alwaysOpen}
            avatared={avatared}
            canSelectAll={canSelectAll}
            menuClassName={menuClassName}
            clearSearchOnSelect={clearSearchOnSelect}
            closeOnSelect={opts.closeOnSelect}
            disabled={disabled}
            isMultiSelect={isMultiSelect || opts.isMultiSelect}
            menuContent={menuContent}
            noSuggestions={props.noSuggestions}
            onChange={onChange}
            onClearAll={onClearAll}
            onRemove={onRemove}
            onSelect={onSelect}
            onSuggest={onSuggest}
            optionDecorator={optionDecorator}
            options={options}
            optionsType={optionsType}
            overscanCount={overscanCount}
            popoverOptions={popoverOptions}
            rowHeight={rowHeight}
            showDeselectIcon={showDeselectIcon}
            searchable={searchable}
            searchOptions={opts.searchOptions}
            selectMatchOnEnter={selectMatchOnEnter}
            selectedComparator={selectedComparator}
            showSelected={showSelected}
            tooltip={tooltip}
            value={value}
          >
            <Component {...props} ref={ref} />
          </WithMenuComponent>
        </div>
      )
    }

    if (props.tooltip) {
      const tooltipContent =
        typeof props.tooltip === 'string'
          ? props.tooltip
          : (props.tooltip?.content ?? '')

      return (
        <Tooltip disabled={!tooltipContent} text={tooltipContent} theme="light">
          <Component {...props} ref={ref} />
        </Tooltip>
      )
    }

    return <Component {...props} ref={ref} />
  })

  WrappedComponent.displayName = `WithMenu(${componentName})`
  return WrappedComponent
}

WithMenu.propTypes = {
  closeOnSelect: bool,
  component: object,
  disabled: bool,
  onChange: func,
  optionDecorator: func,
  options: array,
  optionsType: string,
  showSelected: bool,
  title: string,
  tooltip: any,
  valid: bool,
  value: array,
}

export default WithMenu
